import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../Icon';
import Eyebrow from '../page/Eyebrow';
import { tie } from '../page/typography';

/**
 * Пов'язана послуга — картка.
 *
 * Посилання — на назві, а на всю картку його розтягує ::after: натискається
 * вся картка, а диктор читає назву послуги, а не опис і підпис підряд.
 */
const RelatedService = ({ service, className = '' }) => (
  <div
    className={`group relative rounded-2xl border border-slate-200 bg-white p-5 hover:border-teal-300 hover:shadow-md transition-[border-color,box-shadow] duration-200 ${className}`}
  >
    <Eyebrow className="mb-3">Пов'язана послуга</Eyebrow>
    <Link
      to={`/poslugy/${service.meta.slug}`}
      className="block font-display text-lg font-bold leading-snug text-slate-900 group-hover:text-teal-800 transition-colors duration-200 after:absolute after:inset-0 after:rounded-2xl focus:outline-none focus-visible:after:ring-2 focus-visible:after:ring-teal-700 focus-visible:after:ring-offset-2"
    >
      {tie(service.meta.h1)}
    </Link>
    <p className="mt-2 text-sm leading-relaxed text-slate-600">{tie(service.meta.description)}</p>
    <span className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-teal-700" aria-hidden="true">
      До послуги
      <Icon name="fa-arrow-right" className="transition-transform duration-200 motion-reduce:transition-none group-hover:translate-x-1" />
    </span>
  </div>
);

export default RelatedService;
